var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup10482(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 221.823,
    height: 113.548,
    viewBox: "0 0 221.823 113.548",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10482"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10468"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10468"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7977",
    d: "M480.5 189.873h-22.442a3.865 3.865 0 0 0-3.86 3.86V206.4a3.864 3.864 0 0 0 3.86 3.859H480.5a3.864 3.864 0 0 0 3.859-3.859v-12.667a3.865 3.865 0 0 0-3.859-3.86zm2.617 16.532a2.62 2.62 0 0 1-2.617 2.617h-22.442a2.62 2.62 0 0 1-2.617-2.617v-12.672a2.62 2.62 0 0 1 2.617-2.617H480.5a2.62 2.62 0 0 1 2.617 2.617z",
    transform: "translate(-295.695 -153.051)",
    style: {
      fill: "#26abe3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7978",
    d: "M470.306 195.681h-2.209l-2.573 3.89-2.433-3.9h-2.193l3.506 5.5-4.025 6h2.184l2.921-4.395 2.821 4.406h2.16l-3.853-6.017z",
    transform: "translate(-297.045 -154.316)",
    style: {
      fill: "#26abe3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7979",
    d: "m476.029 207.191 7.049.014v-1.631l-5.121-.01.008-3.842 4.973.009V200.1l-4.973-.009.005-2.763 5.122.01v-1.631l-7.05-.014z",
    transform: "translate(-300.464 -154.322)",
    style: {
      fill: "#26abe3"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10470"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10469"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7980",
    d: "M324.065 209.7a10.955 10.955 0 0 1 4.162 4.153 11.752 11.752 0 0 1 1.521 5.893 12.458 12.458 0 0 1-1.376 5.9 10.538 10.538 0 0 1-3.82 4.16 10.4 10.4 0 0 1-13.492-2.247l.038 11.254a2.168 2.168 0 0 1-3.642 1.555 2.051 2.051 0 0 1-.61-1.54l-.064-19.007a11.618 11.618 0 0 1 1.5-5.9 11.237 11.237 0 0 1 9.922-5.723 11.542 11.542 0 0 1 5.861 1.502zm-2.027 16.846a7.365 7.365 0 0 0 2.659-2.8 8.077 8.077 0 0 0 .965-3.983 8.213 8.213 0 0 0-.993-4 7.339 7.339 0 0 0-2.677-2.8 7.26 7.26 0 0 0-10.182 2.837 8.368 8.368 0 0 0-.945 4 8.227 8.227 0 0 0 .973 3.978 7.36 7.36 0 0 0 10.2 2.757z",
    transform: "translate(-263.495 -157.053)",
    style: {
      fill: "#26abe3"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10472"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10471"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7981",
    d: "M349.531 229.867a10.455 10.455 0 0 1-4.1-4.091 13 13 0 0 1-.041-11.963 10.457 10.457 0 0 1 4.071-4.119 11.925 11.925 0 0 1 5.956-1.5 11.729 11.729 0 0 1 5.9 1.46 10.645 10.645 0 0 1 4.1 4.092 12.92 12.92 0 0 1 .062 11.963 10.508 10.508 0 0 1-4.051 4.118 11.8 11.8 0 0 1-5.935 1.5 11.934 11.934 0 0 1-5.962-1.46zm9.764-3.3a6.92 6.92 0 0 0 2.617-2.781 8.456 8.456 0 0 0 .924-4.025 8.6 8.6 0 0 0-.951-4.041 6.9 6.9 0 0 0-2.635-2.784 7.773 7.773 0 0 0-7.628.026 7.036 7.036 0 0 0-2.638 2.8 8.432 8.432 0 0 0-.945 4.047 8.316 8.316 0 0 0 .972 4.019 7.06 7.06 0 0 0 2.657 2.763 7.768 7.768 0 0 0 7.628-.026z",
    transform: "translate(-271.615 -157.053)",
    style: {
      fill: "#26abe3"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10474"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10473"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7982",
    d: "M423.844 229.867a10.455 10.455 0 0 1-4.1-4.091 12.993 12.993 0 0 1-.041-11.963 10.462 10.462 0 0 1 4.071-4.119 11.925 11.925 0 0 1 5.956-1.5 11.733 11.733 0 0 1 5.9 1.46 10.649 10.649 0 0 1 4.1 4.092 12.914 12.914 0 0 1 .062 11.963 10.506 10.506 0 0 1-4.05 4.118 11.8 11.8 0 0 1-5.935 1.5 11.93 11.93 0 0 1-5.963-1.46zm9.763-3.3a6.917 6.917 0 0 0 2.617-2.781 8.457 8.457 0 0 0 .923-4.025 8.6 8.6 0 0 0-.95-4.041 6.9 6.9 0 0 0-2.635-2.784 7.773 7.773 0 0 0-7.628.026 7.026 7.026 0 0 0-2.638 2.8 8.424 8.424 0 0 0-.945 4.047 8.316 8.316 0 0 0 .972 4.019 7.053 7.053 0 0 0 2.656 2.763 7.768 7.768 0 0 0 7.628-.026z",
    transform: "translate(-287.847 -157.053)",
    style: {
      fill: "#26abe3"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10475"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7983",
    d: "M391.557 226.034a1.852 1.852 0 0 0-1.013-1.1 7.07 7.07 0 0 1-3.14-2.714 7.413 7.413 0 0 1-1.189-4.023l-.07-20.733a1.87 1.87 0 0 0-.558-1.35 1.927 1.927 0 0 0-2.711.009 1.872 1.872 0 0 0-.549 1.354l.07 20.733a11.16 11.16 0 0 0 1.815 6.113 10.867 10.867 0 0 0 4.773 4.14 1.76 1.76 0 0 0 .793.185 1.94 1.94 0 0 0 1.779-2.614z",
    transform: "translate(-279.996 -154.294)",
    style: {
      fill: "#26abe3"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10476"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7984",
    d: "M409.807 226.034a1.848 1.848 0 0 0-1.012-1.1 7.065 7.065 0 0 1-3.14-2.714 7.413 7.413 0 0 1-1.189-4.023l-.07-20.733a1.87 1.87 0 0 0-.558-1.35 1.927 1.927 0 0 0-2.711.009 1.872 1.872 0 0 0-.549 1.354l.07 20.733a11.153 11.153 0 0 0 1.815 6.113 10.867 10.867 0 0 0 4.773 4.14 1.76 1.76 0 0 0 .793.185 1.939 1.939 0 0 0 1.778-2.614z",
    transform: "translate(-283.983 -154.294)",
    style: {
      fill: "#26abe3"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10479"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10477"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7985",
    d: "m275 215.078-14.6 14.5a17.62 17.62 0 0 0 1.923 1.245 19.159 19.159 0 0 0 9.584 2.345 21.983 21.983 0 0 0 3.088-.231z",
    transform: "translate(-253.364 -158.557)",
    style: {
      fill: "#008bcd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10478"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7986",
    d: "M285.885 199.587a17.106 17.106 0 0 0-6.586-6.573 18.845 18.845 0 0 0-9.484-2.345 19.172 19.172 0 0 0-9.569 2.41 16.811 16.811 0 0 0-6.54 6.618 20.875 20.875 0 0 0 .066 19.219 17.331 17.331 0 0 0 1.575 2.335l18.317-18.193a2.149 2.149 0 0 1 3.664 1.525v21.883a17.547 17.547 0 0 0 2.148-1.041 16.871 16.871 0 0 0 6.507-6.618 20.746 20.746 0 0 0-.1-19.219z",
    transform: "translate(-251.397 -153.225)",
    style: {
      fill: "#008bcd"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8681"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7235",
    d: "M363.208 727.282a2.195 2.195 0 0 0 1.168-.7c3.939-4.235 2.661-13.637-3.235-15.623a.872.872 0 0 0-.947.253 7.631 7.631 0 0 0-.743-.489.889.889 0 0 0-1.207 1.207 11.594 11.594 0 0 1 1.695 5.572 10.189 10.189 0 0 1-1.291 4.571 10.379 10.379 0 0 0-2.2-2.534 1.181 1.181 0 0 0-.693-.287 5.852 5.852 0 0 0-.8-6.28c-.881-1-2.218.272-1.726 1.332.73 1.574-.3 2.627-1.318 3.665a1.87 1.87 0 0 0 .938 3.112.8.8 0 0 0 .022.491c.577 1.532 1.4 3.4 1.279 5.066a1.8 1.8 0 0 0 .493 1.364 16.471 16.471 0 0 1-4.854.276c-.921-.074-1.133 1.208-.445 1.644 4.598 2.92 10.419 1.159 13.864-2.64z",
    transform: "translate(-185.002 -706.833)",
    style: {
      fill: "#e0dfe6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7934",
    d: "M1108.055 652.388c-2.475-1.378-5.32 1.4-4.687 3.968a4.075 4.075 0 0 0 2.729 2.744 3.846 3.846 0 0 0 3.914-.936 2.518 2.518 0 0 0 .2-3.311 2.7 2.7 0 0 0-1.583-.957 1.249 1.249 0 0 0-.573-1.508z",
    transform: "translate(-939.011 -645.843)",
    style: {
      fill: "#93cbe2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7305",
    d: "M344.751 721.691a3.62 3.62 0 0 1-1.346-2.841 4.2 4.2 0 0 1 3.177-4 2.8 2.8 0 0 1 .552-.054 3.824 3.824 0 0 1 3.748 3.268c0 2.767-1.5 4.419-4 4.419a3.406 3.406 0 0 1-2.014-.706.587.587 0 0 1 .05.051.54.54 0 0 1-.085.759c-.1.082-.2.171-.3.263a4.437 4.437 0 0 0 2.349.713 5.054 5.054 0 0 0 3.132-.99 4.79 4.79 0 0 0-.315-.23.54.54 0 1 1 .6-.9c.167.113.329.236.487.363a5.91 5.91 0 0 0 1.172-3.748 4.85 4.85 0 0 0-4.829-4.349 3.93 3.93 0 0 0-.763.074 5.258 5.258 0 0 0-4.046 5.061 4.663 4.663 0 0 0 1.361 3.319 5.994 5.994 0 0 1 .472-.424.54.54 0 0 1 .598-.048z",
    transform: "translate(-180.768 -708.824)",
    style: {
      fill: "#525d7d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7306",
    d: "M342.871 736.9c.1-.092.2-.181.3-.263a.54.54 0 0 0 .085-.759.575.575 0 0 0-.05-.051.532.532 0 0 0-.116-.087.54.54 0 0 0-.594.053 6.005 6.005 0 0 0-.472.424 8.747 8.747 0 0 0-2.3 6.158 11.891 11.891 0 0 0 1.086.724 16.45 16.45 0 0 1-.009-.541 7.8 7.8 0 0 1 2.07-5.658z",
    transform: "translate(-179.107 -722.872)",
    style: {
      fill: "#525d7d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7307",
    d: "M340.425 758.426c-.059-.037-.116-.076-.174-.113a.541.541 0 0 0 .174.113z",
    transform: "translate(-179.442 -737.355)",
    style: {
      fill: "#525d7d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7308",
    d: "M375.315 758.677c-.045.032-.091.061-.136.093a.539.539 0 0 0 .136-.093z",
    transform: "translate(-201.788 -737.588)",
    style: {
      fill: "#525d7d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7309",
    d: "M363.463 735.382a7.607 7.607 0 0 0-.487-.364.54.54 0 1 0-.6.9c.107.072.212.151.315.23a9.919 9.919 0 0 1 3.331 6.646 11.416 11.416 0 0 0 .984-.714 10.815 10.815 0 0 0-3.543-6.698z",
    transform: "translate(-193.441 -722.393)",
    style: {
      fill: "#525d7d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7310",
    d: "M343.411 721.318c.045-.031.091-.061.136-.093a12.618 12.618 0 0 0 5.246-9.728c0-7.981-8.224-11.361-11.5-11.361a13.231 13.231 0 0 0-4.9 1.173 11.591 11.591 0 0 0-6.872 10.626 11.059 11.059 0 0 0 5.306 9.16c.058.037.115.077.174.114a12.9 12.9 0 0 0 6.806 1.941 9.8 9.8 0 0 0 5.604-1.832zm-16.811-9.384a10.487 10.487 0 0 1 6.2-9.625 12.261 12.261 0 0 1 4.495-1.093c2.869 0 10.416 3.161 10.416 10.28a10.821 10.821 0 0 1-4.133 8.322 11.383 11.383 0 0 1-.984.714 9.007 9.007 0 0 1-4.786 1.535 12.1 12.1 0 0 1-6.083-1.7 11.9 11.9 0 0 1-1.086-.724 9.588 9.588 0 0 1-4.039-7.709z",
    transform: "translate(-170.02 -700.136)",
    style: {
      fill: "#525d7d"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10480"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7235",
    d: "M363.208 727.282a2.195 2.195 0 0 0 1.168-.7c3.939-4.235 2.661-13.637-3.235-15.623a.872.872 0 0 0-.947.253 7.631 7.631 0 0 0-.743-.489.889.889 0 0 0-1.207 1.207 11.594 11.594 0 0 1 1.695 5.572 10.189 10.189 0 0 1-1.291 4.571 10.379 10.379 0 0 0-2.2-2.534 1.181 1.181 0 0 0-.693-.287 5.852 5.852 0 0 0-.8-6.28c-.881-1-2.218.272-1.726 1.332.73 1.574-.3 2.627-1.318 3.665a1.87 1.87 0 0 0 .938 3.112.8.8 0 0 0 .022.491c.577 1.532 1.4 3.4 1.279 5.066a1.8 1.8 0 0 0 .493 1.364 16.471 16.471 0 0 1-4.854.276c-.921-.074-1.133 1.208-.445 1.644 4.598 2.92 10.419 1.159 13.864-2.64z",
    transform: "translate(-340.505 -617.833)",
    style: {
      fill: "#e0dfe6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7934",
    d: "M1108.055 652.388c-2.475-1.378-5.32 1.4-4.687 3.968a4.075 4.075 0 0 0 2.729 2.744 3.846 3.846 0 0 0 3.914-.936 2.518 2.518 0 0 0 .2-3.311 2.7 2.7 0 0 0-1.583-.957 1.249 1.249 0 0 0-.573-1.508z",
    transform: "translate(-1094.514 -556.843)",
    style: {
      fill: "#93cbe2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7305",
    d: "M344.751 721.691a3.62 3.62 0 0 1-1.346-2.841 4.2 4.2 0 0 1 3.177-4 2.8 2.8 0 0 1 .552-.054 3.824 3.824 0 0 1 3.748 3.268c0 2.767-1.5 4.419-4 4.419a3.406 3.406 0 0 1-2.014-.706.587.587 0 0 1 .05.051.54.54 0 0 1-.085.759c-.1.082-.2.171-.3.263a4.437 4.437 0 0 0 2.349.713 5.054 5.054 0 0 0 3.132-.99 4.79 4.79 0 0 0-.315-.23.54.54 0 1 1 .6-.9c.167.113.329.236.487.363a5.91 5.91 0 0 0 1.172-3.748 4.85 4.85 0 0 0-4.829-4.349 3.93 3.93 0 0 0-.763.074 5.258 5.258 0 0 0-4.046 5.061 4.663 4.663 0 0 0 1.361 3.319 5.994 5.994 0 0 1 .472-.424.54.54 0 0 1 .598-.048z",
    transform: "translate(-336.271 -619.824)",
    style: {
      fill: "#525d7d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7306",
    d: "M342.871 736.9c.1-.092.2-.181.3-.263a.54.54 0 0 0 .085-.759.575.575 0 0 0-.05-.051.532.532 0 0 0-.116-.087.54.54 0 0 0-.594.053 6.005 6.005 0 0 0-.472.424 8.747 8.747 0 0 0-2.3 6.158 11.891 11.891 0 0 0 1.086.724 16.45 16.45 0 0 1-.009-.541 7.8 7.8 0 0 1 2.07-5.658z",
    transform: "translate(-334.61 -633.872)",
    style: {
      fill: "#525d7d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7307",
    d: "M340.425 758.426c-.059-.037-.116-.076-.174-.113a.541.541 0 0 0 .174.113z",
    transform: "translate(-334.945 -648.355)",
    style: {
      fill: "#525d7d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7308",
    d: "M375.315 758.677c-.045.032-.091.061-.136.093a.539.539 0 0 0 .136-.093z",
    transform: "translate(-357.291 -648.588)",
    style: {
      fill: "#525d7d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7309",
    d: "M363.463 735.382a7.607 7.607 0 0 0-.487-.364.54.54 0 1 0-.6.9c.107.072.212.151.315.23a9.919 9.919 0 0 1 3.331 6.646 11.416 11.416 0 0 0 .984-.714 10.815 10.815 0 0 0-3.543-6.698z",
    transform: "translate(-348.944 -633.393)",
    style: {
      fill: "#525d7d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7310",
    d: "M343.411 721.318c.045-.031.091-.061.136-.093a12.618 12.618 0 0 0 5.246-9.728c0-7.981-8.224-11.361-11.5-11.361a13.231 13.231 0 0 0-4.9 1.173 11.591 11.591 0 0 0-6.872 10.626 11.059 11.059 0 0 0 5.306 9.16c.058.037.115.077.174.114a12.9 12.9 0 0 0 6.806 1.941 9.8 9.8 0 0 0 5.604-1.832zm-16.811-9.384a10.487 10.487 0 0 1 6.2-9.625 12.261 12.261 0 0 1 4.495-1.093c2.869 0 10.416 3.161 10.416 10.28a10.821 10.821 0 0 1-4.133 8.322 11.383 11.383 0 0 1-.984.714 9.007 9.007 0 0 1-4.786 1.535 12.1 12.1 0 0 1-6.083-1.7 11.9 11.9 0 0 1-1.086-.724 9.588 9.588 0 0 1-4.039-7.709z",
    transform: "translate(-325.523 -611.136)",
    style: {
      fill: "#525d7d"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8688"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7235",
    d: "M363.208 727.282a2.195 2.195 0 0 0 1.168-.7c3.939-4.235 2.661-13.637-3.235-15.623a.872.872 0 0 0-.947.253 7.631 7.631 0 0 0-.743-.489.889.889 0 0 0-1.207 1.207 11.594 11.594 0 0 1 1.695 5.572 10.189 10.189 0 0 1-1.291 4.571 10.379 10.379 0 0 0-2.2-2.534 1.181 1.181 0 0 0-.693-.287 5.852 5.852 0 0 0-.8-6.28c-.881-1-2.218.272-1.726 1.332.73 1.574-.3 2.627-1.318 3.665a1.87 1.87 0 0 0 .938 3.112.8.8 0 0 0 .022.491c.577 1.532 1.4 3.4 1.279 5.066a1.8 1.8 0 0 0 .493 1.364 16.471 16.471 0 0 1-4.854.276c-.921-.074-1.133 1.208-.445 1.644 4.598 2.92 10.419 1.159 13.864-2.64z",
    transform: "translate(-157.886 -630.107)",
    style: {
      fill: "#e0dfe6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7934",
    d: "M1108.055 652.388c-2.475-1.378-5.32 1.4-4.687 3.968a4.075 4.075 0 0 0 2.729 2.744 3.846 3.846 0 0 0 3.914-.936 2.518 2.518 0 0 0 .2-3.311 2.7 2.7 0 0 0-1.583-.957 1.249 1.249 0 0 0-.573-1.508z",
    transform: "translate(-911.896 -569.117)",
    style: {
      fill: "#93cbe2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7305",
    d: "M344.751 721.691a3.62 3.62 0 0 1-1.346-2.841 4.2 4.2 0 0 1 3.177-4 2.8 2.8 0 0 1 .552-.054 3.824 3.824 0 0 1 3.748 3.268c0 2.767-1.5 4.419-4 4.419a3.406 3.406 0 0 1-2.014-.706.587.587 0 0 1 .05.051.54.54 0 0 1-.085.759c-.1.082-.2.171-.3.263a4.437 4.437 0 0 0 2.349.713 5.054 5.054 0 0 0 3.132-.99 4.79 4.79 0 0 0-.315-.23.54.54 0 1 1 .6-.9c.167.113.329.236.487.363a5.91 5.91 0 0 0 1.172-3.748 4.85 4.85 0 0 0-4.829-4.349 3.93 3.93 0 0 0-.763.074 5.258 5.258 0 0 0-4.046 5.061 4.663 4.663 0 0 0 1.361 3.319 5.994 5.994 0 0 1 .472-.424.54.54 0 0 1 .598-.048z",
    transform: "translate(-153.653 -632.098)",
    style: {
      fill: "#525d7d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7306",
    d: "M342.871 736.9c.1-.092.2-.181.3-.263a.54.54 0 0 0 .085-.759.575.575 0 0 0-.05-.051.532.532 0 0 0-.116-.087.54.54 0 0 0-.594.053 6.005 6.005 0 0 0-.472.424 8.747 8.747 0 0 0-2.3 6.158 11.891 11.891 0 0 0 1.086.724 16.45 16.45 0 0 1-.009-.541 7.8 7.8 0 0 1 2.07-5.658z",
    transform: "translate(-151.992 -646.146)",
    style: {
      fill: "#525d7d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7307",
    d: "M340.425 758.426c-.059-.037-.116-.076-.174-.113a.541.541 0 0 0 .174.113z",
    transform: "translate(-152.327 -660.629)",
    style: {
      fill: "#525d7d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7308",
    d: "M375.315 758.677c-.045.032-.091.061-.136.093a.539.539 0 0 0 .136-.093z",
    transform: "translate(-174.672 -660.862)",
    style: {
      fill: "#525d7d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7309",
    d: "M363.463 735.382a7.607 7.607 0 0 0-.487-.364.54.54 0 1 0-.6.9c.107.072.212.151.315.23a9.919 9.919 0 0 1 3.331 6.646 11.416 11.416 0 0 0 .984-.714 10.815 10.815 0 0 0-3.543-6.698z",
    transform: "translate(-166.325 -645.667)",
    style: {
      fill: "#525d7d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7310",
    d: "M343.411 721.318c.045-.031.091-.061.136-.093a12.618 12.618 0 0 0 5.246-9.728c0-7.981-8.224-11.361-11.5-11.361a13.231 13.231 0 0 0-4.9 1.173 11.591 11.591 0 0 0-6.872 10.626 11.059 11.059 0 0 0 5.306 9.16c.058.037.115.077.174.114a12.9 12.9 0 0 0 6.806 1.941 9.8 9.8 0 0 0 5.604-1.832zm-16.811-9.384a10.487 10.487 0 0 1 6.2-9.625 12.261 12.261 0 0 1 4.495-1.093c2.869 0 10.416 3.161 10.416 10.28a10.821 10.821 0 0 1-4.133 8.322 11.383 11.383 0 0 1-.984.714 9.007 9.007 0 0 1-4.786 1.535 12.1 12.1 0 0 1-6.083-1.7 11.9 11.9 0 0 1-1.086-.724 9.588 9.588 0 0 1-4.039-7.709z",
    transform: "translate(-142.905 -623.41)",
    style: {
      fill: "#525d7d"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8689"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7235",
    d: "M363.208 727.282a2.195 2.195 0 0 0 1.168-.7c3.939-4.235 2.661-13.637-3.235-15.623a.872.872 0 0 0-.947.253 7.631 7.631 0 0 0-.743-.489.889.889 0 0 0-1.207 1.207 11.594 11.594 0 0 1 1.695 5.572 10.189 10.189 0 0 1-1.291 4.571 10.379 10.379 0 0 0-2.2-2.534 1.181 1.181 0 0 0-.693-.287 5.852 5.852 0 0 0-.8-6.28c-.881-1-2.218.272-1.726 1.332.73 1.574-.3 2.627-1.318 3.665a1.87 1.87 0 0 0 .938 3.112.8.8 0 0 0 .022.491c.577 1.532 1.4 3.4 1.279 5.066a1.8 1.8 0 0 0 .493 1.364 16.471 16.471 0 0 1-4.854.276c-.921-.074-1.133 1.208-.445 1.644 4.598 2.92 10.419 1.159 13.864-2.64z",
    transform: "translate(-144.818 -694.559)",
    style: {
      fill: "#e0dfe6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7934",
    d: "M1108.055 652.388c-2.475-1.378-5.32 1.4-4.687 3.968a4.075 4.075 0 0 0 2.729 2.744 3.846 3.846 0 0 0 3.914-.936 2.518 2.518 0 0 0 .2-3.311 2.7 2.7 0 0 0-1.583-.957 1.249 1.249 0 0 0-.573-1.508z",
    transform: "translate(-898.827 -633.569)",
    style: {
      fill: "#93cbe2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7305",
    d: "M344.751 721.691a3.62 3.62 0 0 1-1.346-2.841 4.2 4.2 0 0 1 3.177-4 2.8 2.8 0 0 1 .552-.054 3.824 3.824 0 0 1 3.748 3.268c0 2.767-1.5 4.419-4 4.419a3.406 3.406 0 0 1-2.014-.706.587.587 0 0 1 .05.051.54.54 0 0 1-.085.759c-.1.082-.2.171-.3.263a4.437 4.437 0 0 0 2.349.713 5.054 5.054 0 0 0 3.132-.99 4.79 4.79 0 0 0-.315-.23.54.54 0 1 1 .6-.9c.167.113.329.236.487.363a5.91 5.91 0 0 0 1.172-3.748 4.85 4.85 0 0 0-4.829-4.349 3.93 3.93 0 0 0-.763.074 5.258 5.258 0 0 0-4.046 5.061 4.663 4.663 0 0 0 1.361 3.319 5.994 5.994 0 0 1 .472-.424.54.54 0 0 1 .598-.048z",
    transform: "translate(-140.585 -696.549)",
    style: {
      fill: "#525d7d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7306",
    d: "M342.871 736.9c.1-.092.2-.181.3-.263a.54.54 0 0 0 .085-.759.575.575 0 0 0-.05-.051.532.532 0 0 0-.116-.087.54.54 0 0 0-.594.053 6.005 6.005 0 0 0-.472.424 8.747 8.747 0 0 0-2.3 6.158 11.891 11.891 0 0 0 1.086.724 16.45 16.45 0 0 1-.009-.541 7.8 7.8 0 0 1 2.07-5.658z",
    transform: "translate(-138.924 -710.598)",
    style: {
      fill: "#525d7d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7307",
    d: "M340.425 758.426c-.059-.037-.116-.076-.174-.113a.541.541 0 0 0 .174.113z",
    transform: "translate(-139.259 -725.081)",
    style: {
      fill: "#525d7d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7308",
    d: "M375.315 758.677c-.045.032-.091.061-.136.093a.539.539 0 0 0 .136-.093z",
    transform: "translate(-161.604 -725.314)",
    style: {
      fill: "#525d7d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7309",
    d: "M363.463 735.382a7.607 7.607 0 0 0-.487-.364.54.54 0 1 0-.6.9c.107.072.212.151.315.23a9.919 9.919 0 0 1 3.331 6.646 11.416 11.416 0 0 0 .984-.714 10.815 10.815 0 0 0-3.543-6.698z",
    transform: "translate(-153.257 -710.119)",
    style: {
      fill: "#525d7d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7310",
    d: "M343.411 721.318c.045-.031.091-.061.136-.093a12.618 12.618 0 0 0 5.246-9.728c0-7.981-8.224-11.361-11.5-11.361a13.231 13.231 0 0 0-4.9 1.173 11.591 11.591 0 0 0-6.872 10.626 11.059 11.059 0 0 0 5.306 9.16c.058.037.115.077.174.114a12.9 12.9 0 0 0 6.806 1.941 9.8 9.8 0 0 0 5.604-1.832zm-16.811-9.384a10.487 10.487 0 0 1 6.2-9.625 12.261 12.261 0 0 1 4.495-1.093c2.869 0 10.416 3.161 10.416 10.28a10.821 10.821 0 0 1-4.133 8.322 11.383 11.383 0 0 1-.984.714 9.007 9.007 0 0 1-4.786 1.535 12.1 12.1 0 0 1-6.083-1.7 11.9 11.9 0 0 1-1.086-.724 9.588 9.588 0 0 1-4.039-7.709z",
    transform: "translate(-129.836 -687.862)",
    style: {
      fill: "#525d7d"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10481"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7235",
    d: "M363.208 727.282a2.195 2.195 0 0 0 1.168-.7c3.939-4.235 2.661-13.637-3.235-15.623a.872.872 0 0 0-.947.253 7.631 7.631 0 0 0-.743-.489.889.889 0 0 0-1.207 1.207 11.594 11.594 0 0 1 1.695 5.572 10.189 10.189 0 0 1-1.291 4.571 10.379 10.379 0 0 0-2.2-2.534 1.181 1.181 0 0 0-.693-.287 5.852 5.852 0 0 0-.8-6.28c-.881-1-2.218.272-1.726 1.332.73 1.574-.3 2.627-1.318 3.665a1.87 1.87 0 0 0 .938 3.112.8.8 0 0 0 .022.491c.577 1.532 1.4 3.4 1.279 5.066a1.8 1.8 0 0 0 .493 1.364 16.471 16.471 0 0 1-4.854.276c-.921-.074-1.133 1.208-.445 1.644 4.598 2.92 10.419 1.159 13.864-2.64z",
    transform: "translate(-299.798 -694.559)",
    style: {
      fill: "#e0dfe6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7934",
    d: "M1108.055 652.388c-2.475-1.378-5.32 1.4-4.687 3.968a4.075 4.075 0 0 0 2.729 2.744 3.846 3.846 0 0 0 3.914-.936 2.518 2.518 0 0 0 .2-3.311 2.7 2.7 0 0 0-1.583-.957 1.249 1.249 0 0 0-.573-1.508z",
    transform: "translate(-1053.807 -633.569)",
    style: {
      fill: "#93cbe2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7305",
    d: "M344.751 721.691a3.62 3.62 0 0 1-1.346-2.841 4.2 4.2 0 0 1 3.177-4 2.8 2.8 0 0 1 .552-.054 3.824 3.824 0 0 1 3.748 3.268c0 2.767-1.5 4.419-4 4.419a3.406 3.406 0 0 1-2.014-.706.587.587 0 0 1 .05.051.54.54 0 0 1-.085.759c-.1.082-.2.171-.3.263a4.437 4.437 0 0 0 2.349.713 5.054 5.054 0 0 0 3.132-.99 4.79 4.79 0 0 0-.315-.23.54.54 0 1 1 .6-.9c.167.113.329.236.487.363a5.91 5.91 0 0 0 1.172-3.748 4.85 4.85 0 0 0-4.829-4.349 3.93 3.93 0 0 0-.763.074 5.258 5.258 0 0 0-4.046 5.061 4.663 4.663 0 0 0 1.361 3.319 5.994 5.994 0 0 1 .472-.424.54.54 0 0 1 .598-.048z",
    transform: "translate(-295.565 -696.549)",
    style: {
      fill: "#525d7d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7306",
    d: "M342.871 736.9c.1-.092.2-.181.3-.263a.54.54 0 0 0 .085-.759.575.575 0 0 0-.05-.051.532.532 0 0 0-.116-.087.54.54 0 0 0-.594.053 6.005 6.005 0 0 0-.472.424 8.747 8.747 0 0 0-2.3 6.158 11.891 11.891 0 0 0 1.086.724 16.45 16.45 0 0 1-.009-.541 7.8 7.8 0 0 1 2.07-5.658z",
    transform: "translate(-293.904 -710.598)",
    style: {
      fill: "#525d7d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7307",
    d: "M340.425 758.426c-.059-.037-.116-.076-.174-.113a.541.541 0 0 0 .174.113z",
    transform: "translate(-294.239 -725.081)",
    style: {
      fill: "#525d7d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7308",
    d: "M375.315 758.677c-.045.032-.091.061-.136.093a.539.539 0 0 0 .136-.093z",
    transform: "translate(-316.584 -725.314)",
    style: {
      fill: "#525d7d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7309",
    d: "M363.463 735.382a7.607 7.607 0 0 0-.487-.364.54.54 0 1 0-.6.9c.107.072.212.151.315.23a9.919 9.919 0 0 1 3.331 6.646 11.416 11.416 0 0 0 .984-.714 10.815 10.815 0 0 0-3.543-6.698z",
    transform: "translate(-308.237 -710.119)",
    style: {
      fill: "#525d7d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7310",
    d: "M343.411 721.318c.045-.031.091-.061.136-.093a12.618 12.618 0 0 0 5.246-9.728c0-7.981-8.224-11.361-11.5-11.361a13.231 13.231 0 0 0-4.9 1.173 11.591 11.591 0 0 0-6.872 10.626 11.059 11.059 0 0 0 5.306 9.16c.058.037.115.077.174.114a12.9 12.9 0 0 0 6.806 1.941 9.8 9.8 0 0 0 5.604-1.832zm-16.811-9.384a10.487 10.487 0 0 1 6.2-9.625 12.261 12.261 0 0 1 4.495-1.093c2.869 0 10.416 3.161 10.416 10.28a10.821 10.821 0 0 1-4.133 8.322 11.383 11.383 0 0 1-.984.714 9.007 9.007 0 0 1-4.786 1.535 12.1 12.1 0 0 1-6.083-1.7 11.9 11.9 0 0 1-1.086-.724 9.588 9.588 0 0 1-4.039-7.709z",
    transform: "translate(-284.816 -687.862)",
    style: {
      fill: "#525d7d"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup10482);
export default __webpack_public_path__ + "static/media/group-10482.e98c5820fd9ba82350b44fa4b4e473b2.svg";
export { ForwardRef as ReactComponent };